import mime from 'mime';

export const fileToBase64 = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => {
      console.error(error);
      reject(error);
    };
  });

export const base64ToFile = (dataUrl: string, fileName: string) => {
  const array = dataUrl.split(',');
  const mimeType = array[0].match(/:(.*?);/)![1];
  const byteString = atob(array[1]);
  let byteLength = byteString.length;
  const u8arr = new Uint8Array(byteLength);
  while (byteLength) {
    u8arr[byteLength - 1] = byteString.charCodeAt(byteLength - 1);
    byteLength -= 1;
  }
  return new File([u8arr], fileName, { type: mimeType });
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const kiloByte = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(kiloByte));

  // ** = Math.pow(kiloByte,i)
  return `${parseFloat((bytes / kiloByte ** i).toFixed(dm))} ${sizes[i]}`;
};

export const kbToMb = (bytes: number, decimals = 0) => {
  const dm = decimals < 0 ? 0 : decimals;
  return parseFloat((bytes / (1024 * 1024)).toFixed(dm));
};

export const mimeToExt = (mimetype: string) => mime.getExtension(mimetype) || '';
export const extToMime = (ext: string) => mime.getType(ext) || '';
